import { FeaturedProductCard } from "@client/components/product/FeaturedProductCard";
import { SectionDivider } from "@client/components/ui/SectionDivider";
import { SectionHeading } from "@client/components/ui/SectionHeading";
import { useProducts } from "@client/hooks/use-catalog";
import { cn } from "@client/lib/cn";
import { catalogCopy } from "@client/locales/id/catalog";

/**
 * Products the admin marked "Tampilkan sebagai unggulan", in catalog order. Shares the catalog
 * query (no extra request) and renders nothing while loading, on error, or when none is marked:
 * the catalog right below already covers those states.
 */
export function FeaturedSection() {
  const { data: products } = useProducts();
  const featured = (products ?? []).filter((product) => product.isHighlighted);
  if (featured.length === 0) return null;

  // An odd count leads with one wide card, so the two-column grid never leaves an orphan.
  const hasWideLead = featured.length % 2 === 1;

  return (
    <>
      <section className="mx-auto w-full max-w-6xl px-4 pt-8 pb-16 sm:px-6 md:pb-24">
        <SectionHeading
          eyebrow={catalogCopy.featuredEyebrow}
          title={catalogCopy.featuredTitle}
          description={catalogCopy.featuredDescription}
        />
        <div className="mt-10 grid gap-5 md:grid-cols-2">
          {featured.map((product, index) => {
            const isWide = hasWideLead && index === 0;
            return (
              <div key={product.id} className={cn(isWide && "md:col-span-2")}>
                <FeaturedProductCard product={product} isWide={isWide} />
              </div>
            );
          })}
        </div>
      </section>
      <SectionDivider />
    </>
  );
}
